import { CSS } from "@stitches/react";

export const itemStyle: CSS = {
  // Reset
  all: "unset",
  boxSizing: "border-box",

  // Custom
  position: "relative",
  minHeight: "2.75rem",
  padding: "$2 $4",
  borderRadius: "$md",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  fontSize: "$sm",
  fontWeight: 500,
  color: "$neutral-500",
  transition: "$normal",
  gap: "$2",

  "&:hover": {
    backgroundColor: "$neutral-100",
    color: "$neutral-950",
    cursor: "pointer",
    fill: "$neutral-950",
  },

  "&[data-active=true]": {
    backgroundColor: "$primary-50",
    color: "$primary-600",
    fill: "$primary-600",
  },

  "&[data-disabled=true]": {
    pointerEvents: "none",
  },

  "&[data-highlighted]": {},
};
